import { SubscriptionRefTypeId as SubscriptionRefTypeId$1, get as get$1, make as make$1, modify as modify$1, modifyEffect as modifyEffect$1, set as set$1 } from '../../internal/subscriptionRef.esm.js';
import { getAndSet as getAndSet$1, getAndUpdate as getAndUpdate$1, getAndUpdateSome as getAndUpdateSome$1, modifySome as modifySome$1, setAndGet as setAndGet$1, update as update$1, updateAndGet as updateAndGet$1, updateSome as updateSome$1, updateSomeAndGet as updateSomeAndGet$1 } from '../../Ref/dist/effect-Ref.esm.js';
import { getAndUpdateEffect as getAndUpdateEffect$1, getAndUpdateSomeEffect as getAndUpdateSomeEffect$1, modifySomeEffect as modifySomeEffect$1, updateEffect as updateEffect$1, updateAndGetEffect as updateAndGetEffect$1, updateSomeEffect as updateSomeEffect$1, updateSomeAndGetEffect as updateSomeAndGetEffect$1 } from '../../SynchronizedRef/dist/effect-SynchronizedRef.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const SubscriptionRefTypeId = SubscriptionRefTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `SubscriptionRef<A>` is a `Ref` that can be subscribed to in order to
 * receive the current value as well as all changes to the value.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category getters
 */
const get = get$1;

/**
 * @since 2.0.0
 * @category utils
 */
const getAndSet = getAndSet$1;

/**
 * @since 2.0.0
 * @category utils
 */
const getAndUpdate = getAndUpdate$1;

/**
 * @since 2.0.0
 * @category utils
 */
const getAndUpdateEffect = getAndUpdateEffect$1;

/**
 * @since 2.0.0
 * @category utils
 */
const getAndUpdateSome = getAndUpdateSome$1;

/**
 * @since 2.0.0
 * @category utils
 */
const getAndUpdateSomeEffect = getAndUpdateSomeEffect$1;

/**
 * Creates a new `SubscriptionRef` with the specified value.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * @since 2.0.0
 * @category utils
 */
const modify = modify$1;

/**
 * @since 2.0.0
 * @category utils
 */
const modifyEffect = modifyEffect$1;

/**
 * @since 2.0.0
 * @category utils
 */
const modifySome = modifySome$1;

/**
 * @since 2.0.0
 * @category utils
 */
const modifySomeEffect = modifySomeEffect$1;

/**
 * @since 2.0.0
 * @category utils
 */
const set = set$1;

/**
 * @since 2.0.0
 * @category utils
 */
const setAndGet = setAndGet$1;

/**
 * @since 2.0.0
 * @category utils
 */
const update = update$1;

/**
 * @since 2.0.0
 * @category utils
 */
const updateEffect = updateEffect$1;

/**
 * @since 2.0.0
 * @category utils
 */
const updateAndGet = updateAndGet$1;

/**
 * @since 2.0.0
 * @category utils
 */
const updateAndGetEffect = updateAndGetEffect$1;

/**
 * @since 2.0.0
 * @category utils
 */
const updateSome = updateSome$1;

/**
 * @since 2.0.0
 * @category utils
 */
const updateSomeEffect = updateSomeEffect$1;

/**
 * @since 2.0.0
 * @category utils
 */
const updateSomeAndGet = updateSomeAndGet$1;

/**
 * @since 2.0.0
 * @category utils
 */
const updateSomeAndGetEffect = updateSomeAndGetEffect$1;

export { SubscriptionRefTypeId, get, getAndSet, getAndUpdate, getAndUpdateEffect, getAndUpdateSome, getAndUpdateSomeEffect, make, modify, modifyEffect, modifySome, modifySomeEffect, set, setAndGet, update, updateAndGet, updateAndGetEffect, updateEffect, updateSome, updateSomeAndGet, updateSomeAndGetEffect, updateSomeEffect };
